(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timantti-collection-grid"] && !Shopify.designMode) return;
  try {
    
  // Submit the sort form on change — no JS framework needed.
  document.querySelectorAll('[data-tt-sort-form]').forEach((form) => {
    form.querySelector('select').addEventListener('change', () => form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timantti-launch-countdown"] && !Shopify.designMode) return;
  try {
    
  // Heading + CTA swap when the embedded <tt-countdown> finishes.
  // We listen at section root so multiple sections on a page don't cross-fire.
  document.querySelectorAll('[data-tt-launch]').forEach((section) => {
    section.addEventListener('tt:countdown-complete', () => {
      section.querySelectorAll('[data-tt-pre]').forEach((el) => (el.hidden = true));
      section.querySelectorAll('[data-tt-post]').forEach((el) => (el.hidden = false));
    });
    // Also handle the case where the datetime is already past on page load —
    // the <tt-countdown> will tick once, fire complete, and we'll swap.
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timantti-product"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     Timantti product page — variant picker + qty + ATC behaviour
     - No Dawn dependencies, uses inline JSON product.variants
     - Labels and preorder flag come from the form's data-tt-* attributes
       because Liquid output is NOT processed inside {% javascript %} blocks.
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-tt-product]').forEach(initProduct);

    function initProduct(root) {
      const form        = root.querySelector('[data-tt-form]');
      if (!form) return;
      const idInput     = root.querySelector('[data-tt-id-input]');
      const optionInputs= root.querySelectorAll('[data-tt-option-input]');
      const priceCurrent= root.querySelector('[data-tt-price-current]');
      const priceCompare= root.querySelector('[data-tt-price-compare]');
      const atcBtn      = root.querySelector('[data-tt-atc]');
      const atcLabel    = root.querySelector('[data-tt-atc-label]');
      const qtyInput    = root.querySelector('[data-tt-qty-input]');
      const qtyBtns     = root.querySelectorAll('[data-tt-qty-step]');
      const optValueDisplays = root.querySelectorAll('[data-tt-option-value]');

      // Locate inlined variant JSON for this section instance
      const sectionEl = root.closest('[id^="shopify-section-"]');
      const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
      const dataNode  = document.querySelector('[data-tt-variants-' + sectionId + ']');
      let variants = [];
      try { variants = JSON.parse(dataNode.textContent); } catch (e) {}

      // Labels live on the form's data attributes (Liquid-rendered server-side)
      const baseLabels = {
        addToCart:   form.dataset.ttLabelAdd       || 'Add to cart',
        preorder:    form.dataset.ttLabelPreorder  || 'Pre-order now',
        soldOut:     form.dataset.ttLabelSoldout   || 'Sold out',
        unavailable: form.dataset.ttLabelUnavailable || 'Unavailable'
      };
      const isPreorder = form.dataset.ttPreorder === 'true';

      // Currency formatter — falls back to Shopify.formatMoney if Dawn loaded it
      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
        }
        const value = (cents / 100).toFixed(2);
        return 'R ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function getSelectedOptions() {
        const groups = {};
        optionInputs.forEach((inp) => {
          if (inp.checked) {
            const idx = parseInt(inp.dataset.ttOptionIndex, 10);
            groups[idx] = inp.value;
          }
        });
        // Return options ordered by option index so we can match against variant.options[]
        return Object.keys(groups)
          .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
          .map((k) => groups[k]);
      }

      function findVariant(selectedOptions) {
        if (!variants.length) return null;
        return variants.find((v) =>
          v.options.every((opt, idx) => opt === selectedOptions[idx])
        );
      }

      function updateUI(variant) {
        if (!variant) {
          atcBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = baseLabels.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;

        // Price
        if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
        if (priceCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompare.textContent = formatMoney(variant.compare_at_price);
            priceCompare.hidden = false;
          } else {
            priceCompare.hidden = true;
          }
        }

        // Availability
        if (variant.available) {
          atcBtn.disabled = false;
          if (atcLabel) atcLabel.textContent = isPreorder ? baseLabels.preorder : baseLabels.addToCart;
        } else {
          atcBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = baseLabels.soldOut;
        }

        // Reflect variant in URL so refresh / share keeps the selection
        if (window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        // Update the small option-value labels (e.g. "Colour: Sage")
        optValueDisplays.forEach((el, i) => {
          el.textContent = variant.options[i] || '';
        });
      }

      optionInputs.forEach((inp) => {
        inp.addEventListener('change', () => updateUI(findVariant(getSelectedOptions())));
      });

      qtyBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const delta = parseInt(btn.dataset.ttQtyStep, 10);
          qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) + delta);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
